// Una edición de un campo del borrador: la hace el vendedor a mano o la PROPONE la IA ("corrige X") y el vendedor la
// aplica. "antes" es lo que la persona vio: si ya no coincide con lo guardado, la edición TRUENA (EDICION_DESACTUALIZADA)
// en lugar de pisar el cambio de otra persona.
import { z } from 'zod';

/** Lo más que mide el «motivo» de una edición del historial. Quien arma una edición con un texto más largo (la nota de un costo,
 *  hasta NOTA_COSTO_MAX) lo recorta: el texto entero ya va en «despues». */
export const MOTIVO_EDICION_MAX = 300;

export const EdicionCampo = z.strictObject({
  op: z.enum(['reemplazar', 'agregar', 'quitar']),
  /** JSON pointer (RFC 6901) relativo al contenido del borrador: "/lecturas/A/historial/3/consumo_kwh".
   *  Para agregar al final de una lista: ".../-". */
  ruta: z.string().regex(/^(\/[^/]*)+$/, 'ruta JSON pointer'),
  /** Valor que se vio antes (null al agregar). */
  antes: z.unknown(),
  /** Valor nuevo (null al quitar). */
  despues: z.unknown(),
  motivo: z.string().trim().max(MOTIVO_EDICION_MAX).nullable(),
});
export type EdicionCampo = z.infer<typeof EdicionCampo>;
